import { FormControl } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';


@Component({
  selector: 'ng-xform-field-error-message',
  template: `
    <div class="help-block" *ngIf="control && control.invalid && control.touched">
      <div *ngIf="control.errors" class="alert alert-danger" role="alert" style="padding: 5px;">
        {{ control.errors | errorMessage }}
      </div>
    </div>
  `,
  styles: []
})
export class FieldErrorMessageComponent implements OnInit {

  @Input() control: FormControl;

  ngOnInit() {}

}
